import Backbone from 'backbone'
import _ from 'lodash'

/**
 * Superclass for the portion of a dashboard containing the canvas itself
 * (ie not including the tabs, toolbar, etc). Subclasses exist for the
 * view-only vs editable versions
 */
const CanvasContainerView = Backbone.View.extend({
	className: 'canvas-container',

	initialize (options = {}) {
		this.options = options

		this.formView = options.formView
		this.wobs = options.wobs
		this.maestro = options.maestro

		this.listenTo(this.model.data, 'change', _.bind(function () {
			// When dashboard data is updated, go through each wob and update
			// the data on the widget
			this.wobs.each(wob => {
				wob.widget.data && wob.widget.data.set(this.model.data)
			})
		}.bind(this)))

		this.listenTo(this.model.data, 'fetching', () => {
			// When dashboard data is fetching, go through each wob trigger 'fetching'
			// for its copy of the data
			this.wobs.each(wob => {
				wob.widget.data && wob.widget.data.trigger('fetching')
			})
		})

		this.listenTo(this.wobs, 'add remove', this._toggleIsEmpty.bind(this))
	},

	render () {
		this.canvas = this.createCanvas()

		this.listenTo(this.canvas, 'ready', () => {
			this.trigger('ready')
		})

		// Attach the dashboard model to the canvas so widgets can see it; specifically
		// needed by text-widget-view
		this.canvas.dashboard = this.model

		// add canvas element to the DOM before rendering, since it's needed
		// for certain widgets (like speedometers) and it needs to be in the
		// DOM before 'ready' is emitted (issue #9697)
		this.$el.append(this.canvas.el)
		this.canvas.build().render()

		this.model.maestro = this.maestro
		_(this.canvas.views).values().forEach(v => this.maestro.add(v.view))
		this.maestro.queryAll()

		this._toggleIsEmpty()

		return this
	},

	_toggleIsEmpty () {
		this.$('.canvas').toggleClass('is-empty', this.wobs.length === 0)
	},

	resizeCanvas () {
		this.canvas.resize()
	},

	remove () {
		// Note: not using autoremove because the parent view is passing in a
		// lot of things like formView and maestro that should be removed there
		Backbone.View.prototype.remove.apply(this, this.arguments)
		_.invoke(this.canvas, 'release')
	}
})

export default CanvasContainerView

CanvasContainerView.__filename__ = 'dashboards/canvas-container-view.js'
